/**
 * When fetching JIRA data, we need to pass a test flag to the JIRA API to
 * indicate whether to query for the tickets with the mcomControl label. This
 * util returns a string ('test') for DEV & QA, and and empty string for PROD.
 * DEV, QA and local = 'test' PROD = ''
 */
export const memberTestFlag = process.env.APP_ENV === 'prod' ? '' : 'test'
